import { env } from "../config/env";
import { getAuthToken } from "../pages/AdminAuth/components/authStore";

const BASE = env.AUTH_BASE_URL;

function authHeaders() {
  const token = getAuthToken?.() || "";
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// GET PROFILE
export async function getProfile() {
  const res = await fetch(`${BASE}/api/auth/me`, {
    headers: {
      ...authHeaders(),
    },
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "Failed to fetch profile");

  return data?.admin;
}

// UPDATE PROFILE (onboarding API)
export async function updateProfile(formData) {
  const res = await fetch(`${BASE}/api/auth/onboarding`, {
    method: "PATCH",
    headers: {
      ...authHeaders(),
    },
    body: formData,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "Profile update failed");

  return data;
}